// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4000":"50077682db396e83","6497":"b58d7702df6062c5","9465":"2327690c5f1d3664"}[chunkId] + ".js";
};